import React, { lazy, Suspense } from 'react';
import { Loading } from '../../components';
const GwpRedemption = lazy(() => import('./gwpRedemptionForm'));

export function GwpRedemptionLazy(props) {
  return <div style={{ backgroundColor: 'white', margin: '0 auto', maxWidth: '1110px' }}>
    <Suspense fallback={<Loading />}>
      <GwpRedemption />
    </Suspense>
  </div>
}
